

import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "../../Styles/ViewFeeStructure2.css";
import { Printer, AlertCircle } from "lucide-react";
import html2pdf from "html2pdf.js";

// --- API Imports ---
import ApiConfig from "../../api/ApiConfig";
import { simplePostCall } from "../../api/ApiServices";

// --- Toastify Imports ---
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ViewFeeStructure2 = ({data,onBack,  loadDataStudentFee}) => {
 
  // --------------------
  // STATE
  // --------------------
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
const navigate = useNavigate()
  const { feeStructure, from, feeStructureFromCreate } = location.state || {};
console.log('from---', from , feeStructureFromCreate, location.state)
  const { id } = useParams(); // id = "cay25"


  const [gradeName, setGradeName] = useState("");
  const [academicName, setAcademicName] = useState("");

  const [feeData, setFeeData] = useState([]);
  const [summary, setSummary] = useState([]);

// --------------------
  // API CALL (REFERENCE STYLE)
  // --------------------
  const loadFeeStructure = async () => {
    setIsLoading(true);
    try {
      const requestBody = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") ||
          "b9359f494e77b6589ce12dd62518c585",
        grade: from === 'create-fee' ? feeStructureFromCreate:  data?.class_id ,
        academic: id,
      };

      const response = await simplePostCall(
        ApiConfig.viewFeeStructure,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        // 1. Set standard fields
        setGradeName(response?.data?.[0]?.grade_name || ""); // New JSON uses 'grade' instead of 'grade_name'
        setAcademicName(response?.data?.[0]?.academic_year_name || ""); // New JSON dropped 'academic_name', so fallback to the ID string

        // 2. Group the flat data array by Term
        const groupedByTerm = [];
        const termTracker = {};

        if (Array.isArray(response.data)) {
          response.data.forEach((item) => {
            // If we haven't seen this term yet, create a new group for it
            if (!termTracker[item.term_id]) {
              termTracker[item.term_id] = {
                terms_name: item.term_name,
                elements: [],
              };
              groupedByTerm.push(termTracker[item.term_id]);
            }

            // Map the nested bonuses_discounts array to match your UI's expected variable names
            const mappedSubItems = (item.bonuses_discounts || []).map((bd) => ({
              fee_category_name: bd.name,
              fee_category_amount_type: bd.amount_type,
              bonus_discount_amount: bd.amount,
            }));

            // Push the main element into the correct term group
            termTracker[item.term_id].elements.push({
              fee_category_name: item.category_name,
              element_amount: item.amount,
              bonus_discount: mappedSubItems,
            });
          });
        }

        setFeeData(groupedByTerm);

        // 3. Map the root 'total_amount' to match your UI's summary array format
        if (response.total_amount) {
          setSummary([
            { "annual_total_amount($)": `$${response.total_amount}` }
          ]);
        } else {
          setSummary([]);
        }

      } else {
        // toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching fee structure:", error);
      toast.error("Something went wrong while loading data");
    } finally {
      setIsLoading(false);
    }
  };
  // --------------------
  // ON LOAD
  // --------------------
  useEffect(() => {
    loadFeeStructure();
  }, []);

  // --------------------
  // PDF
  // --------------------
  const handleDownloadPDF = () => {
    const element = document.querySelector(".FS-main-container");
    const opt = {
      margin: 10,
      filename: `Fee_Structure_View.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  // --------------------
  // DELETE UI
  // --------------------
    const handleFinalDelete = async () => {
  try {
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")) || 1005,
      api_key:
        localStorage.getItem("api_key") ||
        "b9359f494e77b6589ce12dd62518c585",
    
      user_id: Number(localStorage.getItem("user_id")) || 14857,
      language: "en",
    grade: data?.class_id || feeStructure?.fee_structure_grade || "ccs16",
        academic: id || "cay25",
    };

    const response = await simplePostCall(
      ApiConfig.deleteFeeStructure,
      JSON.stringify(requestBody)
    );

    if (response?.result || response?.json?.result ) {
      toast.success("Successfully Deleted!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
  // navigate(`/firstcard/${id}`)
  setTimeout(()=>{
  onBack();
   loadDataStudentFee();
  },3000)
  
      // Optional UX: go back to list view after delete
      // setSelectedClass(null);
    } else {
      toast.error(response?.message || "Delete failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  } catch (error) {
    console.error("Delete Fee Structure Error:", error);
    toast.error("Something went wrong while deleting.", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  }
};

  const confirmDelete = () => {
    toast(
      ({ closeToast }) => (
        <div style={{ padding: "10px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <AlertCircle size={24} color="#e74c3c" />
            <span
              style={{ fontWeight: "600", color: "#333", fontSize: "15px" }}
            >
              Are you sure you want to delete this?
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <button
              onClick={closeToast}
              style={{
                background: "#f1f1f1",
                color: "#333",
                border: "1px solid #ddd",
                padding: "6px 15px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleFinalDelete();
                closeToast();
              }}
              style={{
                background: "#e74c3c",
                color: "#fff",
                border: "none",
                padding: "6px 15px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      ),
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        icon: false,
        style: { width: "350px", borderRadius: "8px" },
      }
    );
  };

  // --------------------
  // UI
  // --------------------
  return (
    <div className="FS-page-wrapper">
      <ToastContainer />

      {isLoading && (
        <div className="FS-loader-overlay">Loading Fee Structure...</div>
      )}

      <div className="FS-main-container">
        <div className="FS-header-special-row">
          <h1 className="FS-title-text">View Fee Structure</h1>
          <div className="FS-header-actions-group">
            <span style={{ fontSize: "13px", color: "#666", marginRight: "10px" }}>
              {/* Display Header <input type="checkbox" defaultChecked /> */}
            </span>

            <button
              className="FS-btn-common FS-btn-print-color"
              onClick={handleDownloadPDF}
            >
              Print <Printer size={16} style={{ marginLeft: "5px" }} />
            </button>

           <button className="FS-btn-common FS-btn-edit-color" onClick={() =>
    navigate(`/update-fee/${id}`, {
      state: { classId: from === 'create-fee' ? feeStructureFromCreate :  data?.class_id   }
    })
  }>
              Edit
            </button>

            <button
              className="FS-btn-common FS-btn-delete-color"
              onClick={confirmDelete}
            >
              Delete
            </button>
          </div>
        </div>

        {/* GRADE + ACADEMIC */}
        <div className="FS-section-row">
          <div className="FS-box-card">
            <div className="FS-details-row">
              <div className="FS-details-label">Grade Name</div>
              <div className="FS-details-value">
                {gradeName || "--"}
              </div>
            </div>
            <div className="FS-details-row">
              <div className="FS-details-label">
                Academic Year Name
              </div>
              <div className="FS-details-value">
                {academicName || "--"}
              </div>
            </div>
          </div>
        </div>

        {/* FEES */}
        {feeData?.length === 0 && !isLoading && (
          <div className="FS-section-row">
            <div className="FS-box-card" style={{ textAlign: "center" }}>
              No Fee Structure Data Found
            </div>
          </div>
        )}

    

{feeData?.map((term, index) => {
  if (!term?.elements || term.elements.length === 0) return null;

  // 🔢 Calculate total amount per term
  const totalAmount = term.elements.reduce(
    (sum, el) => sum + Number(el.element_amount || 0),
    0
  );

  return (
    <div className="FS-section-row" key={index}>
      <div className="FS-box-card">

        {/* 🔴 TERM HEADER */}
        <div className="FS-term-title-bar">
          Terms/Semester : {term.terms_name}
        </div>

        {/* 🔵 ELEMENTS */}
        {term.elements.map((element, elIndex) => {
          const mainTitle = element.fee_category_name;
          const mainAmount = element.element_amount;
          const subItems = element.bonus_discount || [];

          return (
            <div key={elIndex}>

              {/* 🔵 MAIN ITEM (BOLD) */}
              <div className="FS-main-fee-row fw-bold fs-5">
                <span>+ &nbsp; {mainTitle}</span>
                <span className="FS-bold-amount-value">
                  $ {mainAmount}
                </span>
              </div>

              {/* 🟡 SUB ITEMS */}
              {subItems.length > 0 && (
                <div className="FS-sub-item-container ps-4">
                  {subItems.map((sub, sIndex) => (
                    <div
                      key={sIndex}
                      className="FS-sub-item-row d-flex justify-content-between py-1"
                    >
                      <span>
                        {sIndex + 1}. {sub.fee_category_name}
                      </span>
                      <span>
                        {sub.fee_category_amount_type === "percentage"
                          ? `${sub.bonus_discount_amount}%`
                          : `$ ${sub.bonus_discount_amount}`}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}

        {/* 🟢 TOTAL */}
        <div className="FS-total-row d-flex justify-content-between px-4 py-3">
          <span className="fw-semibold">Total Amount</span>
          <span className="FS-bold-amount-value">
            $ {totalAmount}
          </span>
        </div>

      </div>
    </div>
  );
})}



        {/* SUMMARY */}
        {summary.length > 0 && (
          <div className="FS-section-row">
            <div className="FS-box-card">
              <div className="FS-total-summary-row">
                <span>Total Amount</span>
                <span className="FS-bold-amount-value">
                  {summary[0]["annual_total_amount($)"]}
                </span>
              </div>
              <div className="FS-summary-green-bar">
                Summary
              </div>
              <div className="FS-final-footer-box">
                <span>Annual Total Amount</span>
                <span className="FS-bold-amount-value">
                  {summary[0]["annual_total_amount($)"]}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewFeeStructure2;
